import Contents from '../Layouts/Contents'
import Credit from '../Layouts/Credits'
import styles from './index.module.scss'

const Terms = () => {
  return (
    <div>
        <div className={styles.layout}>
            <Contents />
            <div className={styles.start}>
                <div>
                    <h1>Terms and condition</h1>
                    <p>Welcome to Dreamvast!</p>
                    <p>These terms and conditions list the rules and regulations for the use of the RainyServices/Dreamvast website, located at https://dreamvast.ml.</p>
                    <p>When you visit this website, we understand that you accept these terms and conditions. Do not continue to use Dreamvast if you do not agree to perform all of the terms and conditions set forth on this page.</p>
                </div>
                <div style={{ padding: '20px 0px 10px' }}>
                    <h2>Cookies:</h2>
                    <p style={{ padding: '10px 0px' }}>
                        The website uses cookies to help personalize your online experience. 
                        By accessing Dreamvast, you agree to the use of the requested cookies.
                    </p>
                    <p style={{ padding: '10px 0px' }}>
                        A cookie is a text file placed on your hard disk by a website server. 
                        Cookies are not used to run programs or transmit viruses to your computer. 
                        Cookies are uniquely assigned to you and can only be read by the web server in the domain that issued the cookie to you.
                    </p>
                    <p style={{ padding: '10px 0px' }}>
                        We may use cookies to collect, store and track information for statistical or marketing purposes to operate our website. 
                        You can accept or decline Cookies. 
                        There are a number of required Cookies that are necessary for the operation of our website. 
                        These cookies do not require your consent as they are always active. 
                        Please note that by accepting Required Cookies, you are also accepting Third Party Cookies, 
                        which can be used through services provided by third parties if you use such services on our website. 
                        Us, such as a video display window provided by a third party and incorporated into our website.
                    </p>
                </div>
                <div style={{ padding: '5px 0px' }}>
                    <div style={{ padding: '5px 0px' }}>
                        <h2>License:</h2>
                        <p style={{ padding: '10px 0px' }}>
                            Unless otherwise stated, Dreamvast/RainyServices and/or its licensors own the intellectual property rights to all material on Dreamvast. 
                            All intellectual property rights are reserved. 
                            You may access this section from Dreamvast for your own personal use subject to the restrictions set forth in these terms and conditions.
                        </p>
                        <p style={{ padding: '10px 0px' }}>
                            Except for open source projects, you must not:
                        </p>
                    </div>
                    <div className={styles.markdown}>
                        <p>- Copy or republish material from Dreamvast</p>
                        <p>- Sell, rent or sublicense material from Dreamvast</p>
                        <p>- Copy, duplicate or duplicate documents from Dreamvast</p>
                        <p>- Redistribution of content from Dreamvast</p>
                    </div>
                    <div style={{ padding: '5px 0px' }}>
                        <p style={{ padding: '10px 0px' }}>
                            This Agreement shall commence on the date of this Agreement.
                        </p>
                        <p style={{ padding: '5px 0px' }}>
                            Portions of this website provide users with the opportunity to post and exchange opinions and information in certain areas of the site. 
                            Dreamvast/RainyServices does not filter, edit, publish or review comments before they appear on the website. 
                            Comments do not reflect the views and opinions of RainyServices/Dreamvast, its agents and/or affiliates. 
                            Comments reflect the views and opinions of the person posting the comment and their opinions. 
                            To the extent permitted by applicable law, Dreamvast/RainyServices will not be responsible for comment or any liability, 
                            damage or expense caused and/or incurred as a result of any use and/ or posting and/or appearance of comments on this website.
                        </p>
                        <p style={{ padding: '10px 0px' }}>
                            You warrant and represent that:
                        </p>
                    </div>
                    <div className={styles.markdown}>
                        <p>- You have the right to post comments on our website and have all necessary licenses and consents to do so;</p>
                        <p>- The comments do not infringe any intellectual property rights, including but not limited to the copyrights, patents or trademarks of any third parties;</p>
                        <p>- Comments do not contain any defamatory, libelous, offensive, vulgar or other illegal material that is an invasion of privacy.</p>
                        <p>- Comments will not be used to solicit or promote custom business or activity or to present commercial or illegal activities.</p>
                    </div>
                    <div style={{ padding: '5px 0px' }}>
                        <p style={{ padding: '10px 0px' }}>
                            You hereby grant Dreamvast/RainyServices a non-exclusive license to use, 
                            reproduce, edit and permit others to use, reproduce and edit any of your comments in any and all form, format, or media.
                        </p>
                    </div>
                    <div style={{ padding: '5px 0px' }}>
                        <h2>Hyperlinks to our Content:</h2>
                        <p style={{ padding: '10px 0px' }}>
                            The following organizations may link to our website without prior written consent:
                        </p>
                    </div>
                    <div className={styles.markdown}>
                        <p>- Government agencies;</p>
                        <p>- Search tools;</p>
                        <p>- News organizations;</p>
                        <p>- Online directory distributors may link to our website in the same way that they hyperlink to the websites of other listed businesses;</p>
                        <p>- System-wide Accredited Businesses with the exception of calling nonprofits, charity shopping malls and charity fundraising groups may not be affiliated with our website.</p>
                    </div>
                    <div>
                        <p style={{ padding: '10px 0px' }}>
                        These organizations may link to our homepage, to publications, or to other website information, as long as the link: 
                        (a) is not deceptive in any way; 
                        (b) do not falsely imply sponsorship, endorsement or approval of the affiliate and its products and/or services;
                        (c) appropriate to the context of the linking party is website.
                        </p>
                    </div>
                    <div>
                        <p style={{ padding: '10px 0px' }}>
                            We may review and approve other affiliation requests from the following types of organizations:
                        </p>
                    </div>
                    <div className={styles.markdown}>
                        <p>- Commonly known consumer and/or business information sources;</p>
                        <p>- dot.com community sites;</p>
                        <p>- associations or other groups representing charities;</p>
                        <p>- online directory distributor;</p>
                        <p>- Web portal;</p>
                        <p>- accounting, law and consulting firms;</p>
                        <p>- educational institutions and trade associations.</p>
                    </div>
                    <div>
                        <p style={{ padding: '10px 0px' }}>
                        We will accept affiliation requests from these organizations if we decide that: 
                        (a) linking will not cause us to have an unfavorable view of ourselves or of accredited businesses ours; 
                        (b) the organization does not have any negative records with us; 
                        (c) the benefit to us from hyperlink visibility offsets the absence of RainyServices/Dreamvast;
                        (d) the link is in the context of generic resource information.
                        </p>
                    </div>
                    <div>
                        <p style={{ padding: '5px 0px' }}>
                            These organizations may link to our homepage as long as the link: 
                            (a) is not deceptive in any way; 
                            (b) does not falsely imply sponsorship, endorsement or approval of the affiliate and the affiliate is products or services; 
                            (c) appropriate to the context of the linking party is website.
                        </p>
                    </div>
                    <div>
                        <p style={{ padding: '5px 0px' }}>
                            If you are one of the organizations listed in section 2 above and wish to link to our website, 
                            you must notify us by sending an e-mail to RainyServices/Dreamvast. 
                            Please include your name, your organization is name, contact information as well as the URL of your website, 
                            a list of any URLs you intend to link to our site, and a list of URLs on the site. 
                            Our website to which you want to link. Wait 2-3 weeks for a response.
                        </p>
                    </div>
                    <div>
                        <p style={{ padding: '10px 0px' }}>
                            Approved organizations may hyperlink to our website as follows:
                        </p>
                    </div>
                    <div className={styles.markdown}>
                        <p>- By using our company name; or</p>
                        <p>- By using the unified resource locator associated with; or</p>
                        <p>- Use of any other description of our Site linked to that makes sense in the context and format of content on the linking party is website.</p>
                    </div>
                    <div>
                        <p style={{ padding: '10px 0px' }}>
                            Dreamvast/RainyServices logo or other artwork is not allowed to be used for affiliation without a trademark license agreement.
                        </p>
                    </div>
                    <div style={{ padding: '5px 0px' }}>
                        <h2>Content Responsibilities:</h2>
                        <p style={{ padding: '10px 0px' }}>
                            We will not be responsible for any content that appears on your website. 
                            You agree to defend and defend us against all claims made on your website. 
                            No link(s) shall appear on any website that may be construed as libelous, obscene, or criminal, or infringing, violent, or advocating the violation of any other infraction, any which rights belong to a third party.
                        </p>
                    </div>
                    <div style={{ padding: '5px 0px' }}>
                        <h2>Rights Reserved:</h2>
                        <p style={{ padding: '10px 0px' }}>
                            We reserve the right to ask you to remove all links or any specific links to our website. 
                            You consent to the immediate removal of all links to our website upon request. 
                            We also reserve the right to amend these terms and conditions and its affiliate policy at any time. 
                            By repeatedly linking to our website, you agree to be bound by and abide by these linking terms and conditions.
                        </p>
                    </div>
                    <div style={{ padding: '5px 0px' }}>
                        <h2>Remove links from our website:</h2>
                        <p style={{ padding: '10px 0px' }}>
                            If you find any link on our website offensive for any reason, you can contact and notify us at any time. 
                            We will review requests to remove links, but we are under no obligation to respond to you directly.
                        </p>
                        <p style={{ padding: '10px 0px' }}>
                            We do not guarantee that the information on this website is accurate. 
                            We do not guarantee its completeness or accuracy, nor do we promise to guarantee that the website remains available or that the material on the site is updated.
                        </p>
                    </div>
                    <div style={{ padding: '5px 0px' }}>
                        <h2>Disclaimer:</h2>
                        <p style={{ padding: '10px 0px' }}>
                        To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions regarding our website and its use. 
                        Nothing in this disclaimer shall:
                        </p>
                    </div>
                    <div className={styles.markdown}>
                        <p>- limit or exclude our or your liability for death or personal injury;</p>
                        <p>- limit or exclude our or your liability for fraud or misrepresentation;</p>
                        <p>- limit any of our or your liabilities in any manner not permitted by applicable law; or</p>
                        <p>- exclude any liability that we or yours may not be excluded under applicable law.</p>
                    </div>
                    <div>
                        <p style={{ padding: '5px 0px' }}>
                            The limitations and prohibitions of liability set forth in this and other parts of this disclaimer: 
                            (a) subject to the preceding paragraph; 
                            and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, 
                            breach of statutory obligation.
                        </p>
                    </div>
                    <div>
                        <p style={{ padding: '5px 0px' }}>
                            As long as the website and the information and services on it are provided free of charge, we will not be liable for any loss or damage of any kind.
                        </p>
                    </div>



                </div>
            </div>
        </div>
        <Credit />
    </div>
  )
}

export default Terms
